import React from 'react';

const PlusIcon = () => (
  <div>
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 7C14 7.60577 13.4952 8.11058 12.9231 8.11058H8.07692V12.9567C8.07692 13.5288 7.57212 14 7 14C6.39423 14 5.92308 13.5288 5.92308 12.9567V8.11058H1.07692C0.471154 8.11058 0 7.60577 0 7C0 6.42788 0.471154 5.95673 1.07692 5.95673H5.92308V1.11058C5.92308 0.504808 6.39423 0 7 0C7.57212 0 8.07692 0.504808 8.07692 1.11058V5.95673H12.9231C13.4952 5.92308 14 6.42788 14 7Z"
        fill="white"
      />
    </svg>
  </div>
);

export default PlusIcon;
